import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {SimpleDropdown} from '../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdown';
import {SimpleDropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdownItem';
import {
  PopoverCoordinator,
  PopoverTransferProps,
} from '../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {IntegrationModel} from '../../../../models/api/integrationModel';
import {renderAttachmentButton} from './calendarAttachmentButton';

/*
 * Props.
 */

interface CalendarAttachmentsDropdownCoordinatorProps {
  integrations: ReadonlyArray<IntegrationModel>;
  onIntegrationAttachClick: (model: IntegrationModel) => void;
  isDisabled?: boolean;
}

/*
 * Component.
 */

export const CalendarAttachmentsDropdownCoordinator: FC<CalendarAttachmentsDropdownCoordinatorProps> = (
  props,
) => (
  <PopoverCoordinator
    renderButton={(isDropdownOpen) => renderDropdownButton(isDropdownOpen, props.isDisabled)}
    renderModal={(modalProps) => renderDropdown(modalProps, props)}
  />
);

function renderDropdownButton(isDropdownOpen: boolean, isDisabled?: boolean) {
  return renderAttachmentButton({
    buttonText: <Trans id="calendar-attachments-button-attach-files">Attach files</Trans>,
    shouldShowChevron: !isDisabled,
    isDisabled,
    isDropdownOpen,
  });
}

function renderDropdown(
  modalProps: PopoverTransferProps,
  props: CalendarAttachmentsDropdownCoordinatorProps,
) {
  return <SimpleDropdown {...modalProps}>{renderIntegrations(props)}</SimpleDropdown>;
}

function renderIntegrations(props: CalendarAttachmentsDropdownCoordinatorProps) {
  return props.integrations.map((integration) => (
    <SimpleDropdownItem key={integration.id} onSelect={() => props.onIntegrationAttachClick(integration)}>
      <Trans id="calendar-attachments-button-with-integration">With {integration.name}</Trans>
    </SimpleDropdownItem>
  ));
}
